import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/pro-regular-svg-icons";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";

// // // //

/**
 * VisualizationDropdown
 * The overflow menu on a visualization card — the "…" trigger and the display
 * toggles behind it. Split out of VisualizationControls, which pairs this with
 * the API tools + download buttons.
 *
 * Renders nothing when neither toggle is supplied.
 */
export function VisualizationDropdown(props: {
    legend?: {
        value: boolean;
        toggle: () => void;
    };
    navigator?: {
        value: boolean;
        onChange: () => void;
    };
    disabled?: boolean;
}) {
    const { legend, navigator, disabled = false } = props;

    if (legend === undefined && navigator === undefined) {
        return null;
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                disabled={disabled}
                className="flex items-center hover:bg-muted p-2 rounded-full text-secondary-foreground hover:text-accent-foreground focus:outline-hidden"
                data-testid="visualization-controls--dropdown-menu-trigger"
            >
                <span className="sr-only">Open options</span>
                <FontAwesomeIcon
                    className="size-5"
                    aria-hidden="true"
                    icon={faEllipsisH}
                />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="end">
                {legend && (
                    <DropdownMenuItem
                        onClick={() => {
                            legend.toggle();
                        }}
                        data-testid="visualization-controls--toggle-legend"
                        className="cursor-pointer text-secondary-foreground text-sm px-4 py-2 focus:bg-muted"
                    >
                        {legend.value ? "Hide Legend" : "Show Legend"}
                    </DropdownMenuItem>
                )}
                {navigator !== undefined && (
                    <DropdownMenuItem
                        onClick={() => {
                            navigator.onChange();
                        }}
                        data-testid="visualization-controls--toggle-navigator"
                        className="cursor-pointer text-secondary-foreground text-sm px-4 py-2 focus:bg-muted"
                    >
                        {navigator.value
                            ? "Hide Timeframe Controls"
                            : "Show Timeframe Controls"}
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
